$('.block-comparison-slider').each(function() {
    var slider = this;
    var $resize = $(slider).find('.image--before');
    var $handle = $(slider).find('.comparison-bar');
    var handle = $handle[0];
    var dragging = false;

    function setPosition(clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));

        $resize.width(pct + '%');
        $handle.css('left', pct + '%');
    }

    handle.addEventListener('pointerdown', function(e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
        setPosition(e.clientX);
    });

    handle.addEventListener('pointermove', function(e) {
        if (!dragging) return;
        setPosition(e.clientX);
    });

    handle.addEventListener('pointerup', function(e) {
        dragging = false;
        handle.releasePointerCapture(e.pointerId);
    });

    handle.addEventListener('pointercancel', function() {
        dragging = false;
    });
});